import { IEnrollPart } from '@/Model/model'
import { EnrollmentDocument } from '@/Model/enrollment/types'

export interface ApplicationDocumentMapping {
  guid: string
  programId: number
  applicationId: string // The Application GUID
  name: string
  description: string
  documentId: string
  isRequired: boolean
  isCheck: boolean
  isMaster: boolean
  status?: number
  document?: EnrollmentDocument
}

export interface ApplicationBase {
  accountId: number
  applicationDocuments: Array<ApplicationDocumentMapping>
  applicationGuid: string
  createdAt: string // DateTime string
  createdBy: number
  directions: string
  elasticApplicationId: string
  isCompleted: boolean
  isDocumentSubmitted: boolean
  isFormSubmited: boolean
  isPublish: boolean
  isRepublishedAllowed: boolean
  isSubmit: boolean
  modifiedAt?: string // DateTime string
  modifiedBy?: number
  name: string
  programId: number
  programName: string
  scholarId: string
  siteIds: Array<number> // Array of Session IDs
  status: number
}

export interface ApplicationTheme {
  background: string // Hex color
  color: string // Hex color
}

export interface ApplicationScholar {
  scholar_firstname: string // These are snake_case in the response ¯\_(ツ)_/¯
  scholar_lastname: string
}

export interface Application extends ApplicationBase {
  parts: Array<IEnrollPart>
  publishedDate: string // DateTime string
  theme: ApplicationTheme
  timeStamp: string // Epoch timestamp as string
}

export interface ApplicationSubmission {
  formsList: Application
  guardianId: number
  isFinalSubmit: boolean
  scholar: ApplicationScholar
  scholardob: string
  siteIds: number[]
}

export interface DropDownScholarResponse {
  scholarFirstName: string
  scholarLastName: string
  scholarDateOfBirth: string // DateTime string;
  isTemporary: boolean
  guid: string
  siteIds: number[]
}

export enum DuplicateApplicationErrorType {
  InProgress = 0,
  Completed = 1
}
